import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  superBatches: [],
  metaKey: {},
  metaData: {},
};

export const superBatchManagement = createSlice({
  name: 'superBatchManagement',
  initialState,
  reducers: {
    setSuperBatches: (state, action) => {
      state.superBatches = action.payload;
    },
    setMetaKey: (state, action) => {
      state.metaKey = action.payload;
    },
    setMetaData: (state, action) => {
      state.metaData = action.payload;
    },
  },
});

export const { setSuperBatches, setMetaKey, setMetaData } =
  superBatchManagement.actions;

export default superBatchManagement.reducer;
